import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class SignInUiService {
  constructor(private http: HttpClient) {}

  refreshToken() {
    return this.http.get(environment.signInUrl + '/refresh', { withCredentials: true });
  }
}
